import { FUZERX_COLORS } from './fuzerx';

export type ColorTokens = typeof FUZERX_COLORS;

// Internal mutable store. Post-rebrand there is a single brand (FuzeRx), so this is effectively
// constant; the setter remains because startup code (ThemeProvider / applyDesignBrand) still
// assigns it and so a future brand can be reintroduced without re-plumbing consumers.
let COLORS: ColorTokens = FUZERX_COLORS;

export function setColors(colors: ColorTokens) {
  COLORS = colors;
}

export type COLORS_VALUES = ColorTokens[keyof ColorTokens];
export type TEXT_COLORS_VALUES = ColorTokens['TEXT_COLORS'][keyof ColorTokens['TEXT_COLORS']];
export type BORDER_COLORS_VALUES = ColorTokens['BORDER_COLORS'][keyof ColorTokens['BORDER_COLORS']];
export type BACKGROUND_COLORS_VALUES = ColorTokens['BACKGROUND_COLORS'][keyof ColorTokens['BACKGROUND_COLORS']];
export type PALETTE_COLOR_VALUES =
  ColorTokens['PALETTE'][keyof ColorTokens['PALETTE']][keyof ColorTokens['PALETTE'][keyof ColorTokens['PALETTE']]];
export { COLORS, FUZERX_COLORS };
